const getMinMaxPeriodAndAmount = (data) => {
    return data.reduce((acc, item) => {
        acc.minPeriod = Math.min(acc.minPeriod, item.period.min);
        acc.maxPeriod = Math.max(acc.maxPeriod, item.period.max);
        acc.minAmount = Math.min(acc.minAmount, Number(item.amount.min));
        acc.maxAmount = Math.max(acc.maxAmount, Number(item.amount.max));
        return acc;
    }, {
        minPeriod: Infinity,
        maxPeriod: -Infinity,
        minAmount: Infinity,
        maxAmount: -Infinity,
    });
};
export default getMinMaxPeriodAndAmount;
